import { useEffect, useState } from 'react';
import { SearchingIcon } from '@icons';

import { inputStyles } from '@components/input/input.config';

import Icon from '../icon/Icon';

interface SearchBarProps {
  inputId?: string;
  placeholder: string;
  SearchIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onSearch: (searchQuery: string) => void;
  searchBarStyle?: string;
  iconStyle?: string;
  searchInputStyle?: string;
  value?: string;
  clearSearchInput?: any; // prop to clear the local searchText state
}

const SearchBar = ({
  inputId,
  placeholder,
  SearchIcon = SearchingIcon,
  onSearch,
  searchBarStyle,
  iconStyle,
  searchInputStyle,
  value,
  clearSearchInput
}: SearchBarProps) => {
  const [searchText, setSearchText] = useState<string>(value || '');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const handleSearchBarClear = () => {
    setSearchText('');
    onSearch('');
  };

  useEffect(() => {
    setSearchText(value || '');
  }, [value]);

  useEffect(() => {
    if (clearSearchInput) {
      handleSearchBarClear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSearchInput]);

  useEffect(() => {
    const debounceFn = setTimeout(() => {
      onSearch(searchText);
    }, 1000);

    return () => {
      if (debounceFn) clearTimeout(debounceFn);
    };
  }, [searchText, onSearch]);

  return (
    <div className={`relative h-11 ${searchBarStyle || ''}`}>
      {SearchIcon && (
        <SearchIcon
          className={`absolute left-2.5 top-1/2 -translate-y-1/2 ${
            iconStyle && iconStyle
          }`}
        />
      )}
      <input
        data-testid={inputId}
        value={searchText}
        placeholder={placeholder}
        onChange={handleInputChange}
        type="text"
        className={`placeholder:text-text-grey size-full border-grey30 bg-white py-2 pl-10 pr-9 text-sm ${
          inputStyles.common
        } ${searchInputStyle || ''}`}
      />
      {searchText && (
        <div
          role="presentation"
          onClick={handleSearchBarClear}
          className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer"
        >
          <Icon name="close" />
        </div>
      )}
    </div>
  );
};

export default SearchBar;
